import {
	ReactNode,
} from 'react';
import {
	useTranslation,
} from 'react-i18next';
//COMPONENT
import {
	Icon,
} from '@components/icon';
// ENUMS
import {
	EnumFontStyle,
} from '@enums/font.enum';
//STYLES
import styles from './loader.module.scss';

export interface LoaderProps {
	'className'?: string;
	'message'?: ReactNode;
	'data-testid'?: string;
	'data-theme-mode'?: string;
}

export const Loader = ({
	className,
	'data-testid': dataTestid,
	'data-theme-mode': dataThemeMode,
	message,
}: LoaderProps) => {
	const {
		t,
	} = useTranslation();
	const cssClasses = [
		styles.Loader,
	];
	if (className) cssClasses.push(className);

	return (
		<div
			className={cssClasses.join(' ')}
			data-testid={dataTestid}
			data-theme-mode={dataThemeMode}
		>
			<div className={styles.wrapper}>
				<div className={styles.icon}>
					<Icon
						animation="spin"
						fontStyle={EnumFontStyle.LIGHT}
						name="spinner-third"
					/>
				</div>
				<div className={styles.message}>
					{message ? message : t('format.capitalize', {
						text: t('general.loading'),
					})}
				</div>
			</div>
		</div>
	);
};
